import { regionAdapterRegistry, selectableAdapterFactory } from "@uxland/regions";
import { useComponents } from "./components/bootstrapper";
import { useSharedUI } from "./shared-components/bootstrapper";
import { useInternalViews } from "./internal-views/handle-views";

export const useUI = () => {
  regionAdapterRegistry.registerAdapterFactory(
    "primaria-content-switcher",
    selectableAdapterFactory,
  );
  useSharedUI();
  useComponents();
  useInternalViews();
};
